import { defineStore } from "pinia";
import { computed, ref } from "vue";

import type { TopLevelNavigationItem } from "@/types/Cvd.ts";

const useCvdStore = defineStore("cvdStore", () => {
  const navigationItems = ref<TopLevelNavigationItem[]>([]);
  const updatedCvDPageIds = ref<string[]>([]);
  function setupNavigationItems(items: TopLevelNavigationItem[]) {
    navigationItems.value = items;
  }

  function keyValueMapper(items: TopLevelNavigationItem[]) {
    return items.reduce((allItems: Record<string, string>, currentItem) => {
      allItems[currentItem.slug] = currentItem.pageId;
      if (currentItem.children) {
        const children = keyValueMapper(currentItem.children);
        allItems = { ...allItems, ...children };
      }
      return allItems;
    }, {});
  }

  const slugToPageIdMap = computed(() => {
    return keyValueMapper([...navigationItems.value]);
  });

  return {
    navigationItems,
    setupNavigationItems,
    slugToPageIdMap,
    updatedCvDPageIds,
  };
});

export default useCvdStore;
